// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a3Iq6","primary":"styles_primary__gXWuA"};
module.exports.__checksum = "5bd974c4db15"